import { useQuery } from '@apollo/client';
import {
  SearchDocument,
  SearchListFilterInput,
  SearchQuery,
} from 'src/graphql/generated/graphql';
import {
  BasePagination,
  BaseQueryProps,
  BaseSorting,
} from '@otp/ui/src/types/types';

export const useSearch = ({
  pagination,
  onCompleted,
  filter,
  fetchPolicy,
  nextFetchPolicy,
}: BaseQueryProps<
  SearchQuery,
  SearchListFilterInput,
  BasePagination,
  BaseSorting
> = {}) => {
  const { limit = 100, page = 0 } = pagination || {};
  const offset = page * limit;
  const actualProps = {
    variables: {
      filter,
      pagination: { limit, offset },
    },
    onCompleted: onCompleted,
    fetchPolicy: fetchPolicy || 'cache-and-network',
    nextFetchPolicy: nextFetchPolicy || 'cache-only',
  };
  return useQuery(SearchDocument, actualProps);
};
